import { createFileRoute } from "@tanstack/react-router";
import AdminStockPicturesStaging from "@/pages/admin/AdminStockPicturesStaging";

export const Route = createFileRoute("/_adminLayout/admin/stock-pictures-review")({
  head: () => ({ meta: [{ title: "Stock Pictures Review | Admin" }, { name: "robots", content: "noindex" }] }),
  component: AdminStockPicturesStaging,
});
